import GithubAuth from 'components/github-auth';
import React from 'react';
import { GithubLink } from 'components/onboarding/form-components/github-link';

export const GithubSettings = () => {
  return (
    <>
      <h2>GitHub Authentication</h2>
      <GithubAuth />
      <h2>GitHub App Installation</h2>
      <GithubLink />
    </>
  );
};
``;
